export default __webpack_public_path__ + "static/media/race_of_the_reapers_1.116e85b4.png";